import React from 'react'
import { connect } from 'react-redux';
import classes from './AddProductPage.module.scss';
import { localization } from '../../../../Utils/Localization/localization';
import { Input, Button } from 'antd';
import { IPhoto } from '../../../../Utils/types';

interface StateProps { }
interface DispatchProps { }
interface Props extends StateProps, DispatchProps {
  language: string,
  img: IPhoto,
  uploadPhoto: (file: any) => void,
  handleSubmit: () => void
}

function UploadPhoto(props: Props) {
  return (
    <div className={classes.AddProductPage}>
      <h2>{localization('addImg', props.language)}</h2>
      <div className={classes.Icon}>
        <span className={classes.Span}>{localization('preview', props.language)}</span>
        <img src={props.img.huge} alt="PhotoProduct" />
        <Input
          type={'file'}
          onChange={props.uploadPhoto}
          accept={'image/*'}
          name={'Photo'}
        />
        <Button
          onClick={props.handleSubmit}
          disabled={!props.img}
        >
          {localization('done', props.language)}
        </Button>
      </div>
    </div>
  );
}

function mapStateToProps(state: any) {
  return {}
}
const mapDispatchToProps = {}

const ConnectedUploadPhoto = connect(mapStateToProps, mapDispatchToProps)(UploadPhoto);
export { ConnectedUploadPhoto as UploadPhoto };